import { Injectable } from '@angular/core';
import { openDB, DBSchema } from 'idb';

interface CacheDB extends DBSchema {
  responses: {
    key: string;
    value: unknown;
  };
}

@Injectable({ providedIn: 'root' })
export class CacheService {
  private dbPromise = openDB<CacheDB>('cache-db', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('responses')) {
        db.createObjectStore('responses');
      }
    },
  });

  async save(url: string, body: unknown) {
    const db = await this.dbPromise;
    await db.put('responses', body, url);
  }

  async get(url: string) {
    const db = await this.dbPromise;
    return db.get('responses', url);
  }
}
